import { usePrefersReducedMotion } from '@chakra-ui/react';
import { cssAnimations } from '../foundations/animations';
export function useCssAnimation(key) {
  var prefersReducedMotion = usePrefersReducedMotion();
  var animation = cssAnimations[key];
  return prefersReducedMotion ? undefined : "".concat(animation.keyframes, " ").concat(animation === null || animation === void 0 ? void 0 : animation.animation);
}
//# sourceMappingURL=useAnimations.js.map